import { ListBookMetadataType } from "types/ReadingJournalType";
import Icon from "hardcover-ui/components/Icon";
import Text from "hardcover-ui/components/Text";
import faList from "icons/regular/list.svg";
import TextLink from "hardcover-ui/components/TextLink";
import { ReadingJournalEventProps } from "./types";

export default function ListBook({ journal }: ReadingJournalEventProps) {
  const metadata = journal.metadata as ListBookMetadataType;
  return (
    <Text variant="secondary" className="flex flex-row items-center gap-2">
      <Icon icon={faList} />
      <span>Added to list</span>
      <TextLink href={`/@${metadata.username}/lists/${metadata.slug}`}>
        {metadata.list_name}
      </TextLink>
    </Text>
  );
}
